import type { CSSProperties } from 'react'
import DOMPurify from 'dompurify'

interface SafeHtmlProps {
  html: string
  className?: string
  style?: CSSProperties
}

/** Renderizza HTML generato dall'utente (contenuto Knowledge Base/FAQ, non template email - * per quelli vedi HtmlPreviewFrame, che isola in un iframe invece di sanificare) sanificandolo
 * con DOMPurify prima di iniettarlo nel DOM: senza questo passaggio un <script>/onerror=...
 * scritto in un campo "ContentHtml"/"AnswerHtml" veniva eseguito per ogni utente che visitava
 * la pagina (XSS memorizzato, nessuna sanificazione client o server esisteva prima di questo). */
export function SafeHtml({ html, className, style }: SafeHtmlProps) {
  const clean = DOMPurify.sanitize(html)
  return <div className={className} style={style} dangerouslySetInnerHTML={{ __html: clean }} />
}
